import { getEnv } from "../../config/Config";
import { eaFetch } from "../common/ApiUtils";

export async function getCurrentUserSigRoles(dispatch) {
  return eaFetch(
    dispatch,
    getEnv("REACT_APP_EDGE"),
    "GET",
    "365/user-sig/current/roles"
  );
}